var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotoStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37954 0.677813L7.64141 3.55594C7.6889 3.66424 7.76458 3.75781 7.86055 3.8269C7.95652 3.89599 8.06927 3.93807 8.18704 3.94875L11.2611 4.22438C11.6089 4.275 11.7477 4.70156 11.4955 4.94719L9.17985 6.8925C8.99235 7.05 8.90704 7.2975 8.9586 7.53656L9.63172 10.6875C9.69079 11.0334 9.32797 11.2978 9.01672 11.1337L6.3336 9.5625C6.23241 9.50308 6.11719 9.47175 5.99985 9.47175C5.8825 9.47175 5.76729 9.50308 5.6661 9.5625L2.98297 11.1328C2.67266 11.2959 2.30891 11.0325 2.36797 10.6866L3.0411 7.53562C3.09172 7.29656 3.00735 7.04906 2.81985 6.89156L0.503286 4.94812C0.252036 4.70344 0.390786 4.27594 0.737661 4.22531L3.81172 3.94969C3.92949 3.93901 4.04224 3.89693 4.13821 3.82784C4.23418 3.75875 4.30986 3.66517 4.35735 3.55687L5.61922 0.67875C5.77579 0.36375 6.22391 0.36375 6.37954 0.677813Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28791 3.72836L6.07416 1.60773C6.06572 1.48961 6.04135 1.28711 6.23072 1.28711C6.38072 1.28711 6.46228 1.5993 6.46228 1.5993L7.10353 3.3018C7.34541 3.94961 7.24604 4.1718 7.0126 4.30305C6.74447 4.45305 6.34885 4.33586 6.28791 3.72836Z",
    fill: "#FFFF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93253 6.70394L10.7719 5.26863C10.8628 5.19269 11.0269 5.07176 10.8957 4.93394C10.7916 4.82519 10.5103 4.98176 10.5103 4.98176L8.90065 5.61082C8.42065 5.77676 8.1019 6.02238 8.07378 6.33176C8.03721 6.74426 8.40753 7.06207 8.93253 6.70394Z",
    fill: "#F4B400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoStar);
export default __webpack_public_path__ + "static/media/noto_star.affa13af7f9cbe54c0e56b58306223c7.svg";
export { ForwardRef as ReactComponent };